/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { GetProviders1$Params, getProviders1 } from '../fn/meta/get-providers-1';
import { Metadata } from '../models/metadata';

/**
 * Meta API
 */
@Injectable({ providedIn: 'root' })
export class MetaService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getProviders1()` */
   static readonly GetProviders1Path = '/api/weather/meta';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getProviders1()` instead.
    *
    * This method doesn't expect any request body.
    */
   getProviders1$Response(
      params?: GetProviders1$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Metadata>> {
      return getProviders1(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getProviders1$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getProviders1(params?: GetProviders1$Params, context?: HttpContext): Observable<Metadata> {
      return this.getProviders1$Response(params, context).pipe(
         map((r: StrictHttpResponse<Metadata>): Metadata => r.body)
      );
   }
}
